import BotaoLotacoes from '../components/BotaoLotacoes';
import Links from '@/shared/constants/navegacao';
import { ColaboradorEnum, ColaboradorList } from '../../enums/tipo-vinculo.enum';
import { Column } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadPersonDto } from '@/api.types';
import { convertToGMTPlus3 } from '@/shared/utils/datas';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { validaCPF } from '@/shared/utils/cpfs';

// Colunas Visão Geral.
export const colunasGeral: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "nome", header: "Nome",
    render: (row) => (<>{row.nome} {row.sobrenome}</>)
  },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "telefone.numero", header: "Telefone", invisible: true },
  { key: "celular.numero", header: "Celular", invisible: true },
  { key: "defensor", header: "Defensor?", invisible: true, render: (row) => <>{row.defensor ? 'SIM' : '-'}</> },
  { key: "estagiario", header: "Estagiário?", invisible: true, render: (row) => <>{row.estagiario ? 'SIM' : '-'}</> },
  { key: "usuario", header: "Usuário?", invisible: true, render: (row) => <>{row.usuario ? 'SIM' : '-'}</> },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={Links.Pessoa_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];

// Colunas Defensor.
export const colunasDefensor: Column<ReadPersonDto>[] = [
  {
    key: "nome", header: "Nome",
    render: (row) =>
      row.defensor?.ativo
        ? row.nome
        : <span className="text-muted">{row.nome} (inativo)</span>
  },
  {
    key: "dataNascimento",
    header: "Nascimento",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  {
    key: "defensor.data_admissao",
    header: "Admissão",
    type: "date",
    render: (row) =>
      row.defensor?.data_admissao
        ? format(new Date(convertToGMTPlus3(row.defensor.data_admissao)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "defensor.data_referencia",
    header: "Referência",
    type: "date",
    render: (row) =>
      row.defensor?.data_referencia
        ? format(new Date(convertToGMTPlus3(row.defensor.data_referencia)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "defensor.data_exoneracao",
    header: "Exoneração",
    type: "date",
    render: (row) =>
      row.defensor?.data_exoneracao
        ? format(new Date(convertToGMTPlus3(row.defensor.data_exoneracao)), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.defensor?.id ? (
        <BotaoLotacoes
          tipoPessoa="defensor"
          pessoaId={row.defensor.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "timeline", header: "Linha do Tempo",
    render: (row) =>
      <>
        {row.defensor &&
          <Link className="link-secondary" to={`${Links.Defensor_Timeline}?id=${row.defensor?.id}`}>
            Linha do Tempo
          </Link>}
      </>
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={Links.Defensor_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];

// Colunas Estagiários.
export const colunasEstagiarios: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  {
    key: "nome", header: "Nome",
    render: (row) =>
      row.estagiario?.ativo
        ? row.nome
        : <span className="text-muted">{row.nome} (inativo)</span>
  },
  {
    key: "estagiario.estagios.data_inicio_estagio",
    header: "Início do Estágio",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.data_inicio_estagio
        ? format(new Date(row.estagiario.estagios[0].data_inicio_estagio), "dd/MM/yyyy", { locale: ptBR })
        : "N/A"
  },
  {
    key: "estagiario.estagios.data_fim_estagio",
    header: "Fim do Estágio",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.data_fim_estagio
        ? format(new Date(row.estagiario.estagios[0].data_fim_estagio), "dd/MM/yyyy", { locale: ptBR })
        : "N/A"
  },
  {
    key: "estagiario.estagios.desligamento",
    header: "Desligamento",
    type: "date",
    render: (row) =>
      row.estagiario?.estagios?.[0]?.desligamento
        ? format(new Date(row.estagiario.estagios[0].desligamento), "dd/MM/yyyy", { locale: ptBR })
        : "-"
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "estagiario.estagios.0.email", header: "E-mail Estágio", invisible: true },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.estagiario?.id ? (
        <BotaoLotacoes
          tipoPessoa="estagiario"
          pessoaId={row.estagiario.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={Links.Estagiario_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];

// Colunas Usuários.
export const colunasUsuarios: Column<ReadPersonDto>[] = [
  { key: "usuario.username", header: "Nome de Usuário" },
  {
    key: "nome", header: "Nome",
    render: (row) => {
      const n = row.sobrenome ? row.nome.concat(' ', row.sobrenome) : row.nome;
      return (
        <>
          {row.usuario?.ativo ? n : <span className="text-muted">{n}{row.usuario?.ativo ? '' : ' (inativo)'}</span>}
        </>
      )
    }
  },
  { key: "usuario.funcao", header: "Função" },
  { key: "usuario.papel.nome", header: "Papel no Sistema" },
  {
    key: "usuario.recebenotificacoes", header: "Notificações",
    render: (row) => {
      return (<>{
        <input
          title="Recebe notificações"
          type="checkbox"
          checked={row.usuario?.recebenotificacoes}
          readOnly={true}
        >
        </input>}
      </>)
    }
  },
  {
    key: "acoes", header: "Ações", render: (row) =>
      <Link className="link-secondary" to={Links.Usuario_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];


// Colunas Colaborador.
export const colunasColaboradores: Column<ReadPersonDto>[] = [
  { key: "cpf", header: "CPF", render: (row) => validaCPF(row.cpf!, true), invisible: true },
  {
    key: "nome", header: "Nome",
    render: (row) => (<>{row.nome} {row.sobrenome}</>)
  },
  { key: "colaborador.funcao_nome", header: "Função", render: (row) => <>{row.colaborador?.funcao?.nome}</> },
  { key: "colaborador.orgao_origem", header: "Orgão Origem", invisible: false, render: (row) => <>{row.colaborador?.orgao_origem}</> },
  {
    key: "dataNascimento",
    header: "Aniversário",
    type: "date",
    invisible: true,
    render: (row) =>
      row.dataNascimento ? format(new Date(row.dataNascimento), "dd/MM/yyyy", { locale: ptBR }) : ''
  },
  { key: "email", header: "E-mail", invisible: true },
  { key: "emailInstitucional", header: "E-mail Institucional", invisible: true },
  { key: "telefone.numero", header: "Telefone", invisible: true },
  { key: "celular.numero", header: "Celular", invisible: true },
  {
    key: "colaborador.tipo_vinculo",
    header: "Tipo de Vínculo",
    invisible: false,
    render: (row) => {
      const tipoVinculo = ColaboradorList.find(a => a.value == row.colaborador?.tipo_vinculo)?.name || '-';
      const vinculoDireto = row.colaborador?.vinculo_direto;
      const cessaoOnerosa = row.colaborador?.cessao_onerosa;

      return (
        <>
          {tipoVinculo}
          {vinculoDireto && (
            <>
              <br />
              (vínculo direto)
            </>
          )}
          {cessaoOnerosa && (
            <>
              <br />
              (cessão onerosa)
            </>
          )}
          {!cessaoOnerosa && !vinculoDireto && row.colaborador?.tipo_vinculo === ColaboradorEnum.cedido && (
            <>
              <br />
              (cessão não onerosa)
            </>
          )}
        </>
      );
    }
  },
  {
    key: "colaborador.data_cessao", header: "Data Cessão",
    invisible: false,
    type: "date",
    render: (row) =>
      row.colaborador?.data_cessao
        ? format(new Date(row.colaborador?.data_cessao), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "colaborador.data_saida", header: "Data Saída",
    invisible: false,
    render: (row) =>
      row.colaborador?.data_saida
        ? format(new Date(row.colaborador?.data_saida), "dd/MM/yyyy", { locale: ptBR })
        : ''
  },
  {
    key: "lotacoes", header: "Lotações",
    render: (row) =>
      row.colaborador?.id ? (
        <BotaoLotacoes
          tipoPessoa="colaborador"
          pessoaId={row.colaborador.id}
          pessoaNome={row.nome}
        />
      ) : null
  },
  {
    key: "acoes", header: "Ações",
    render: (row) =>
      <Link className="link-secondary" to={Links.Colaborador_Editar + '/' + row.id}>
        Editar
      </Link>
  },
];